var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.flowState==='paid')?_c('Paid',{attrs:{"lesson":_vm.lesson}}):_vm._e(),(_vm.flowState==='not-paid')?_c('NotPaid',{attrs:{"lesson":_vm.lesson}}):_vm._e(),(_vm.flowState==='scheduling')?_c('Scheduled'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }